<template lang="html">
  <h2>
    {{ work_package.name }}
    <small>
      <span v-for="hashtag in work_package.hashtags" :key="hashtag.id" @click="searchForHashtag(hashtag)" class="ml-1 mr-1 blue--text cursor-pointer">#{{hashtag.tag}}</span>
      <v-icon v-if="work_package.country === 'other'" color="primary">flag</v-icon>
      <country-flag v-else :country='work_package.country' size='small'/>
    </small>
  </h2>
</template>

<script>
import CountryFlag from 'vue-country-flag'

export default {
  name: 'WorkPackageHeaderDetails',
  props: [ 'work_package' ],
  components: {
    CountryFlag
  },
  methods: {
    searchForHashtag(hashtag){
      this.$emit('hashtagSearchClick', {
        hashtags: hashtag.tag
      });
    }
  }
}
</script>

<style lang="css" scoped>
</style>
